import React from 'react'
import styled from 'styled-components'
import {
  SortableDragHandle
} from 'components/Sortable';

const Container = styled.div`
  width: 100%;
  margin-top: 65px;
  background: #FFFFFF;
  z-index: 1;
`

const Header = styled.div`
  display: flex;
  padding: 0.5rem 0;
  align-items: center;
`
const Subheader = styled.div`
  display: flex;
  align-items: center;
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const DragHandle = styled.div`
  margin: 0 1rem 0 0;
  cursor: move;
`

const FormSection = ({
  title,
  subtitle,
  children,
  sortable
}) => (
  <Container>
    <Header>
      <SortableDragHandle disable={!sortable}>{sortable && <DragHandle>=</DragHandle>}</SortableDragHandle>
      {title}
    </Header>
    <Subheader>
      {subtitle}
    </Subheader>
    <Wrapper>
      {children}
    </Wrapper>
  </Container>
)

export default FormSection